import React from "react";
import PublicSiteLayout from "./PublicSiteLayout";
import "./PublicInformationPages.css";

export default function LegalDocumentPage({ title, description, effective, sections }) {
  const contents = <nav>{sections.map((section) => <a key={section.num} href={`#policy-${section.num}`}>{section.title}</a>)}</nav>;
  return <PublicSiteLayout className="pi-page">
    <section className="ps-wrap pi-hero">
      <span className="ps-eyebrow">Snows ProAm policies</span>
      <h1>{title}</h1>
      <p className="ps-lead">{description}</p>
      <p className="pi-date">Effective: {effective}</p>
    </section>
    <div className="ps-wrap pi-document-layout">
      <aside className="pi-contents" aria-label="On this page">
        <div className="pi-desktop-contents"><h2>On this page</h2>{contents}</div>
        <details className="pi-mobile-contents"><summary>On this page</summary>{contents}</details>
      </aside>
      <article className="pi-document" aria-label={title}>
        {sections.map((section) => <section id={`policy-${section.num}`} key={section.num}>
          <h2>{section.title}</h2>
          {section.body && <p>{section.body}</p>}
          {section.bullets && <dl>{section.bullets.map((bullet) => <div key={bullet.label}><dt>{bullet.label}</dt><dd>{bullet.detail}</dd></div>)}</dl>}
          {section.list && <ul>{section.list.map((item) => <li key={item}>{item}</li>)}</ul>}
          {section.subSections?.map((sub) => <div className="pi-subsection" key={sub.title}><h3>{sub.title}</h3>{sub.body && <p>{sub.body}</p>}{sub.list && <ul>{sub.list.map((item) => <li key={item}>{item}</li>)}</ul>}</div>)}
          {section.note && <p className="pi-note">{section.note}</p>}
        </section>)}
        <div className="pi-contact-note"><h2>Questions about this policy?</h2><a href="mailto:support@snowsproam.com">support@snowsproam.com</a></div>
      </article>
    </div>
  </PublicSiteLayout>;
}
